import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './App.css';
import Profile from './pages/Profile';
import SendMessage from './pages/SendMessage';
import LIFFWindow from './pages/LIFFWindow';
import EnterEmail from './pages/EnterEmail';
import ChangeEmail from './pages/ChangeEmail';
import SalesIQ from './pages/SalesIQ';
import PureSalesIQ from './pages/PureSalesIQ';
import BasicSalesIQ from './pages/BasicSalesIQ';
import SalesIQProjectDataSample from './pages/SalesIQProjectDataSample';
import Header from './pages/components/Header';

class App extends Component {
  render() {
    return (
      <div className="app">
        {/* <Header /> */}
        <Router>
          <React.Fragment>
            <Route exact path="/profile" component={Profile} />
            <Route path="/message" component={SendMessage} />
            <Route path="/window" component={LIFFWindow} />
            <Route path="/liff/pure_sales_iq" component={PureSalesIQ} />
            <Route path="/liff/basic/sales_iq/:liff_id/:widget_code" component={BasicSalesIQ} />
            <Route path="/liff/sales_iq/:liff_id" component={SalesIQ} />
            <Route path="/liff/sales_iq_p_sample" component={SalesIQProjectDataSample} />

            <Route path="/liff/enter_email/:liff_id" component={EnterEmail} />
            <Route path="/liff/change_email/:liff_id" component={ChangeEmail} />
          </React.Fragment>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js